var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDfDonationButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 266.496,
    height: 40,
    viewBox: "0 0 266.496 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PoweredByDF",
    transform: "translate(-24 -271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    transform: "translate(-431.998 39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149968",
    "data-name": "Rectangle 149968",
    width: 40,
    height: 40,
    transform: "translate(456 232)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Visa-dark",
    transform: "translate(455.998 240)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 40,
    height: 24,
    rx: 2,
    fill: "#26337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M0,7.586,1.223,0H3.177L1.955,7.586H0",
    transform: "translate(16.5 8.142)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M5.865.318A4.832,4.832,0,0,0,4.114,0C2.181,0,.821,1.029.809,2.5.8,3.594,1.78,4.2,2.521,4.564c.762.371,1.018.609,1.015.941-.005.508-.608.741-1.17.741a3.915,3.915,0,0,1-1.841-.4L.273,5.728,0,7.426a5.9,5.9,0,0,0,2.178.4c2.054,0,3.388-1.017,3.4-2.591.007-.865-.514-1.52-1.642-2.061-.683-.352-1.1-.585-1.1-.941,0-.315.354-.653,1.12-.653a3.428,3.428,0,0,1,1.463.291l.176.087L5.865.318",
    transform: "translate(19.68 8.01)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M2.053,7.581H0L2.9.629A.964.964,0,0,1,3.927,0H5.438L7.019,7.58H5.205s-.177-.86-.238-1.136l-1.376,0h0l-1.124,0c-.075.2-.408,1.131-.411,1.14ZM3.805,2.768v0c-.064.173-.625,1.707-.778,2.117H4.649C4.574,4.522,4.212,2.774,4.2,2.7l-.132-.656c-.051.148-.125.348-.178.495v0c-.058.158-.081.223-.081.226Z",
    transform: "translate(25.121 8.149)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M4.826,0,2.913,5.172l-.2-1.051A5.825,5.825,0,0,0,0,.938L1.75,7.573H3.819L6.9,0H4.826",
    transform: "translate(10.035 8.148)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M3.178,0H.026L0,.157A6.561,6.561,0,0,1,4.749,4.125L4.064.64A.821.821,0,0,0,3.178,0",
    transform: "translate(7.993 8.143)",
    fill: "#ec982d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MasterCard",
    transform: "translate(-48.998 65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149970",
    "data-name": "Rectangle 149970",
    width: 40,
    height: 40,
    transform: "translate(121.002 206)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MasterCard-dark",
    transform: "translate(121.111 214.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 40,
    height: 24,
    rx: 2,
    transform: "translate(-0.11 -0.279)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_333",
    "data-name": "Fill 333",
    d: "M15.536,7.768A7.768,7.768,0,1,1,7.768,0a7.768,7.768,0,0,1,7.768,7.768",
    transform: "translate(6.835 4.394)",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_334",
    "data-name": "Fill 334",
    d: "M7.594,0A7.741,7.741,0,0,0,2.379,2.011a7.918,7.918,0,0,0-.784.822H3.164a7.971,7.971,0,0,1,.592.823H1a7.8,7.8,0,0,0-.448.823H4.2a7.736,7.736,0,0,1,.329.822H.226A7.734,7.734,0,0,0,0,6.123H4.758a7.825,7.825,0,0,1,.175,1.645,7.765,7.765,0,0,1-.4,2.468H.226a7.849,7.849,0,0,0,.329.823H4.2a7.782,7.782,0,0,1-.448.823H1a7.832,7.832,0,0,0,.592.822H3.164a7.763,7.763,0,0,1-.785.823A7.768,7.768,0,1,0,7.594,0",
    transform: "translate(17.438 4.394)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_336",
    "data-name": "Fill 336",
    d: "M.77,3.331A.792.792,0,0,1,0,2.456a1.14,1.14,0,0,1,.389-.91,1.685,1.685,0,0,1,1.091-.325,2.9,2.9,0,0,1,.344.025.783.783,0,0,0,.033-.208c0-.213-.147-.292-.541-.292H1.291A2.784,2.784,0,0,0,.424.89C.432.839.536.2.541.17A3.326,3.326,0,0,1,1.55,0a1.192,1.192,0,0,1,.871.281A.893.893,0,0,1,2.657.94a4.082,4.082,0,0,1-.068.635l-.006.038c-.073.463-.225,1.427-.245,1.663h-.7l.016-.332A1.052,1.052,0,0,1,.77,3.331Zm.765-1.5c-.478,0-.72.164-.72.488a.3.3,0,0,0,.3.326c.342,0,.591-.329.606-.8A1.458,1.458,0,0,0,1.535,1.835Z",
    transform: "translate(11.065 11.164)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_337",
    "data-name": "Fill 337",
    d: "M3.382,3.94H2.538L3.022.911,1.943,3.94H1.368L1.3.928.789,3.94H0L.659,0H1.872l.073,2.206L2.685,0H4.034L3.382,3.94",
    transform: "translate(7.331 10.5)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_338",
    "data-name": "Fill 338",
    d: "M.771,3.331A.792.792,0,0,1,0,2.456a1.14,1.14,0,0,1,.39-.91,1.685,1.685,0,0,1,1.091-.325,2.906,2.906,0,0,1,.344.025.783.783,0,0,0,.033-.208c0-.213-.147-.292-.541-.292H1.291A2.8,2.8,0,0,0,.423.89C.432.84.53.24.541.171A3.3,3.3,0,0,1,1.549,0a1.192,1.192,0,0,1,.871.281A.893.893,0,0,1,2.657.94a4.078,4.078,0,0,1-.068.635l-.018.114c-.08.511-.214,1.364-.234,1.588h-.7l.016-.332A1.053,1.053,0,0,1,.771,3.331Zm.765-1.5c-.478,0-.72.164-.72.488a.3.3,0,0,0,.3.326c.342,0,.591-.329.605-.8A1.456,1.456,0,0,0,1.535,1.835Z",
    transform: "translate(24.351 11.164)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_339",
    "data-name": "Fill 339",
    d: "M1.273,3.641a1.927,1.927,0,0,1-.606.1A.617.617,0,0,1,0,3.041a7.4,7.4,0,0,1,.116-.854C.165,1.887.482,0,.482,0H1.32l-.1.485h.506l-.114.77H1.106c-.1.609-.236,1.368-.238,1.469,0,.165.088.237.289.237a.686.686,0,0,0,.227-.03l-.112.709",
    transform: "translate(15.878 10.751)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_340",
    "data-name": "Fill 340",
    d: "M1.438,3.331H1.428A1.452,1.452,0,0,1,.362,2.968,1.453,1.453,0,0,1,0,1.9,2.233,2.233,0,0,1,.417.54,1.314,1.314,0,0,1,1.467,0,1.074,1.074,0,0,1,2.6,1.159a3.411,3.411,0,0,1-.1.788H.827a.558.558,0,0,0,.11.456.8.8,0,0,0,.618.2,1.981,1.981,0,0,0,.872-.2l-.14.8A2.863,2.863,0,0,1,1.438,3.331ZM1.426.73c-.268,0-.458.2-.535.572h.926s0-.01,0-.018A.593.593,0,0,0,1.724.842.382.382,0,0,0,1.426.73Z",
    transform: "translate(17.433 11.164)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_341",
    "data-name": "Fill 341",
    d: "M.319,1.085a.935.935,0,0,0,.642.895c.341.161.395.208.395.354,0,.2-.151.29-.484.29A2.369,2.369,0,0,1,.116,2.5L0,3.237a3.93,3.93,0,0,0,.878.095c.89,0,1.3-.339,1.3-1.071a.877.877,0,0,0-.594-.893c-.353-.162-.394-.2-.394-.348,0-.173.14-.262.413-.262a4.659,4.659,0,0,1,.606.048l.12-.743A5.694,5.694,0,0,0,1.586,0C.643,0,.316.493.319,1.085",
    transform: "translate(13.589 11.164)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_342",
    "data-name": "Fill 342",
    d: "M3.795.976a1.6,1.6,0,0,1,.754.213L4.687.334A2.477,2.477,0,0,0,3.76,0,1.68,1.68,0,0,0,2.383.742c-.49-.162-.691.165-.938.492l-.219.051A1.637,1.637,0,0,0,1.253.963H.478c-.106.992-.293,2-.44,2.989L0,4.167H.844c.141-.915.218-1.5.265-1.9l.318-.176c.048-.177.2-.236.494-.229a3.59,3.59,0,0,0-.06.657c0,1.048.566,1.7,1.474,1.7a2.632,2.632,0,0,0,.746-.115l.148-.9a1.641,1.641,0,0,1-.716.2c-.49,0-.787-.362-.787-.96,0-.868.441-1.476,1.071-1.476",
    transform: "translate(20.027 10.273)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_343",
    "data-name": "Fill 343",
    d: "M2.647,4a.9.9,0,0,1-.739-.364,1.574,1.574,0,0,1-.279-.965,2.745,2.745,0,0,1,.2-1.04H1.806c-.212,0-.344.13-.526.31-.053.052-.108.107-.171.164C1.037,2.65.947,3.27.844,3.94H0l.039-.216c.048-.326.1-.658.153-.98C.3,2.085.407,1.4.478.736h.775c0,.059-.011.229-.037.479a6.846,6.846,0,0,0,.718.2A1.309,1.309,0,0,1,3,.615a1.079,1.079,0,0,1,.8.523L3.993,0h.832L4.183,3.94h-.8l.04-.3A1,1,0,0,1,2.647,4Zm.513-2.5c-.385,0-.654.443-.654,1.077,0,.419.145.632.432.632.394,0,.669-.444.669-1.08C3.607,1.715,3.448,1.492,3.16,1.492Z",
    transform: "translate(26.969 10.5)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_344",
    "data-name": "Fill 344",
    d: "M3.382,3.94H2.538L3.022.911,1.943,3.94H1.368L1.3.929.789,3.94H0L.659,0H1.872l.034,2.439L2.724,0h1.31L3.382,3.94",
    transform: "translate(7.573 10.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_345",
    "data-name": "Fill 345",
    d: "M.77,3.332A.792.792,0,0,1,0,2.456a1.139,1.139,0,0,1,.389-.91,1.686,1.686,0,0,1,1.091-.325,2.816,2.816,0,0,1,.344.025.8.8,0,0,0,.033-.209c0-.212-.147-.291-.541-.291H1.287A2.771,2.771,0,0,0,.424.89C.432.839.536.2.541.17A3.338,3.338,0,0,1,1.55,0a1.25,1.25,0,0,1,.825.239.87.87,0,0,1,.282.7,4.151,4.151,0,0,1-.068.635l-.006.035c-.073.464-.225,1.43-.246,1.666h-.7l.016-.332A1.052,1.052,0,0,1,.77,3.332Zm.765-1.5c-.478,0-.72.164-.72.487a.3.3,0,0,0,.3.327c.342,0,.591-.329.606-.8A1.38,1.38,0,0,0,1.535,1.836Z",
    transform: "translate(11.308 10.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_346",
    "data-name": "Fill 346",
    d: "M2.826.2l-.138.855A1.61,1.61,0,0,0,1.935.847c-.63,0-1.071.609-1.071,1.476,0,.6.3.959.787.959a1.632,1.632,0,0,0,.716-.2l-.148.9a2.632,2.632,0,0,1-.745.116C.566,4.094,0,3.441,0,2.393,0,.984.782,0,1.9,0a2.919,2.919,0,0,1,.927.2",
    transform: "translate(22.13 10.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_347",
    "data-name": "Fill 347",
    d: "M.771,3.332A.792.792,0,0,1,0,2.456a1.139,1.139,0,0,1,.389-.91A1.686,1.686,0,0,1,1.48,1.221a2.826,2.826,0,0,1,.344.025.8.8,0,0,0,.033-.209c0-.212-.147-.291-.541-.291H1.287A2.785,2.785,0,0,0,.423.89C.432.84.529.239.54.171A3.317,3.317,0,0,1,1.549,0a1.192,1.192,0,0,1,.871.281A.893.893,0,0,1,2.657.94a4.057,4.057,0,0,1-.068.635l-.014.09c-.076.484-.217,1.384-.237,1.611h-.7l.016-.332A1.053,1.053,0,0,1,.771,3.332Zm.764-1.5c-.478,0-.72.164-.72.487a.3.3,0,0,0,.3.327c.342,0,.591-.329.605-.8A1.381,1.381,0,0,0,1.535,1.836Z",
    transform: "translate(24.594 10.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_348",
    "data-name": "Fill 348",
    d: "M1.273,3.64a1.926,1.926,0,0,1-.606.1A.617.617,0,0,1,0,3.041a7.416,7.416,0,0,1,.116-.854C.165,1.887.482,0,.482,0H1.32l-.1.485h.43l-.115.77H1.106c-.1.61-.236,1.369-.238,1.469,0,.166.089.237.289.237a.675.675,0,0,0,.227-.03l-.112.709",
    transform: "translate(16.12 10.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_349",
    "data-name": "Fill 349",
    d: "M1.428,3.332A1.452,1.452,0,0,1,.362,2.969,1.454,1.454,0,0,1,0,1.9,2.235,2.235,0,0,1,.417.54,1.313,1.313,0,0,1,1.466,0a1.121,1.121,0,0,1,.826.314A1.179,1.179,0,0,1,2.6,1.16a3.448,3.448,0,0,1-.1.787H.827A.559.559,0,0,0,.938,2.4a.8.8,0,0,0,.618.2,1.98,1.98,0,0,0,.872-.2l-.14.8A2.9,2.9,0,0,1,1.428,3.332Zm0-2.6c-.268,0-.458.2-.536.572h.926s0-.011,0-.019A.594.594,0,0,0,1.724.841.382.382,0,0,0,1.427.73Z",
    transform: "translate(17.676 10.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_350",
    "data-name": "Fill 350",
    d: "M.319,1.085a.936.936,0,0,0,.642.895c.341.161.394.208.394.354,0,.2-.151.29-.484.29A2.376,2.376,0,0,1,.116,2.5L0,3.236a3.9,3.9,0,0,0,.877.1c.89,0,1.3-.339,1.3-1.071a.877.877,0,0,0-.595-.893c-.354-.163-.394-.2-.394-.348,0-.173.14-.262.413-.262a4.69,4.69,0,0,1,.606.049l.12-.743A5.741,5.741,0,0,0,1.586,0C.643,0,.316.493.319,1.085",
    transform: "translate(13.832 10.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_351",
    "data-name": "Fill 351",
    d: "M1.018,4a.9.9,0,0,1-.739-.364A1.574,1.574,0,0,1,0,2.666C0,1.6.628.7,1.372.7a.953.953,0,0,1,.805.437L2.364,0H3.2L2.554,3.94h-.8l.039-.3A1,1,0,0,1,1.018,4Zm.513-2.5c-.385,0-.654.443-.654,1.077,0,.419.145.631.432.631.394,0,.669-.444.669-1.08C1.979,1.715,1.82,1.491,1.532,1.491Z",
    transform: "translate(28.84 10.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_352",
    "data-name": "Fill 352",
    d: "M.478.034c-.105.992-.293,2-.44,2.989L0,3.239H.843c.3-1.959.374-2.342.848-2.294a3.145,3.145,0,0,1,.32-.929C1.658-.059,1.461.141,1.2.52A2.919,2.919,0,0,0,1.253.034H.478",
    transform: "translate(27.212 10.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_353",
    "data-name": "Fill 353",
    d: "M.479.034c-.106.992-.294,2-.44,2.989L0,3.239H.844c.3-1.959.374-2.342.847-2.294A3.165,3.165,0,0,1,2.011.015C1.658-.059,1.461.141,1.2.52a2.9,2.9,0,0,0,.05-.486H.479",
    transform: "translate(20.27 10.968)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AmericanExpress",
    transform: "translate(-96.002 65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149972",
    "data-name": "Rectangle 149972",
    width: 40,
    height: 40,
    transform: "translate(216.002 206)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AmericanExpress-dark",
    transform: "translate(215.674 213.805)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 40,
    height: 24,
    rx: 2,
    transform: "translate(0.326 0.196)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EXPRESS",
    d: "M8.04,4.59h0l-2.569,0-.631-.713-.671.713H0V0H4.248l.61.7L5.508,0H8.352A1.775,1.775,0,0,1,9.463.269V0H12a2.12,2.12,0,0,1,1.062.269V0h3.852V.269A1.509,1.509,0,0,1,17.86,0h2.157V.269A1.657,1.657,0,0,1,21,0h1.458V.654h-1.57c-.834,0-1.131.506-1.131.979,0,.972.805.994,1.515,1.013l.148,0a.4.4,0,0,1,.278.073.272.272,0,0,1,.1.217.29.29,0,0,1-.093.215.441.441,0,0,1-.319.081H19.871v.705h1.522a1.23,1.23,0,0,0,1.069-.421v.855a2.73,2.73,0,0,1-1.156.211H19.264V4.294a1.82,1.82,0,0,1-1.073.293H11.754V3.527c0-.131-.014-.135-.143-.135h-.1v1.2H9.39V3.35a2.511,2.511,0,0,1-.987.162H8.04V4.589Zm8.742-1.353v.705h1.535c.822,0,1.238-.349,1.238-1.038a.916.916,0,0,0-.236-.7,1.259,1.259,0,0,0-.9-.265l-.424-.011a.891.891,0,0,1-.307-.037.253.253,0,0,1-.172-.245.251.251,0,0,1,.118-.236.537.537,0,0,1,.316-.059h1.446v-.7h-1.58c-.831,0-1.127.506-1.127.979,0,.972.8.994,1.513,1.013l.147,0a.416.416,0,0,1,.281.073.282.282,0,0,1,.1.217.292.292,0,0,1-.093.215.456.456,0,0,1-.322.081ZM13.679.654V3.942h2.63V3.26l-1.845,0V2.6h1.8V1.932h-1.8v-.6h1.845V.654ZM10.861,2.741H11.7a.77.77,0,0,1,.578.146.851.851,0,0,1,.128.582c0,.021,0,.042,0,.062v.411H13.2V3.29a.957.957,0,0,0-.131-.6.853.853,0,0,0-.386-.276.918.918,0,0,0,.558-.875.773.773,0,0,0-.405-.73,1.924,1.924,0,0,0-.948-.155H10.069V3.942h.792v-1.2Zm-6.02.112h0l.97,1.088H7.344v-1.1h.983c.923,0,1.372-.36,1.372-1.1A.961.961,0,0,0,9.27.854a1.692,1.692,0,0,0-.9-.2H5.853l-1,1.077L3.881.654H.712V3.942H3.833L4.841,2.854Zm1.717.79h0L5.349,2.3l1.21-1.3V3.642ZM3.434,3.257H1.5V2.6h1.73V1.932H1.5v-.6H3.472l.862.958-.9.964Zm19.028-.967h0l-.01-.013a.346.346,0,0,0-.062-.067,1.241,1.241,0,0,0-.894-.265l-.427-.011a.892.892,0,0,1-.3-.037.248.248,0,0,1-.172-.245.255.255,0,0,1,.115-.237.55.55,0,0,1,.319-.059h1.436v.934Zm-14.1-.118H7.344V1.334H8.371c.22,0,.482.07.482.4C8.853,2.013,8.674,2.171,8.362,2.171Zm3.456-.1h-.957V1.334h.97a.766.766,0,0,1,.376.06.313.313,0,0,1,.163.3A.356.356,0,0,1,12.208,2,.762.762,0,0,1,11.818,2.073Z",
    transform: "translate(11.851 12.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AMERICAN",
    d: "M6.894,4.587H5.518l-.236-.561v.558H2.633l-.3-.73H1.65l-.3.73H0V2.18L.954,0H3.009l.265.541V0h2.41l.527,1.184L6.724,0h7.65a1.277,1.277,0,0,1,.89.268V0h2.094V.268A2.721,2.721,0,0,1,18.674,0h3.035l.282.541V0h2.246l.307.541V0h2.189V4.584H24.52L24.1,3.891v.693H21.341l-.3-.73h-.68l-.307.73H18.623a2.684,2.684,0,0,1-1.264-.279v.279H13.953V3.544c0-.148-.026-.155-.115-.158h-.127l0,1.2H7.13V4.018l-.236.569ZM23.42,1.472h0l1.493,2.466H26.03V.652h-.807V2.941L23.837.652h-1.2V3.761L21.3.652H20.123L19.012,3.237h-.354a.772.772,0,0,1-.549-.169,1.136,1.136,0,0,1-.217-.772,1.088,1.088,0,0,1,.226-.745.754.754,0,0,1,.607-.2h.747v-.7h-.763a1.6,1.6,0,0,0-1.2.383,1.723,1.723,0,0,0-.425,1.285,1.653,1.653,0,0,0,.421,1.255,1.706,1.706,0,0,0,1.143.364h.922l.3-.733h1.637l.307.733H23.42V1.473ZM15.9.652V3.939h.8V.652ZM13.063,2.743h.846a.777.777,0,0,1,.574.14.866.866,0,0,1,.125.578c0,.022,0,.043,0,.063l0,.415h.795V3.293a.943.943,0,0,0-.131-.6.919.919,0,0,0-.39-.277.93.93,0,0,0,.555-.876.771.771,0,0,0-.4-.728,1.843,1.843,0,0,0-.954-.158H12.275V3.939h.788v-1.2ZM9.1.652V3.939h2.633v-.68H9.884V2.6h1.8V1.929h-1.8V1.336h1.845V.652Zm-1.4.714h0l0,2.573h.808V.652H7.2l-.948,2.23L5.218.652H3.932V3.764L2.591.652H1.42L.009,3.939H.865l.306-.733H2.812l.3.733h1.6V1.362L5.863,3.939h.692ZM21.239,2.52H20.152l.542-1.311.545,1.31Zm-18.712,0H1.452L1.988,1.21l.539,1.31ZM14.02,2.066h-.957v-.73h.97a.814.814,0,0,1,.374.059.3.3,0,0,1,.165.291A.338.338,0,0,1,14.41,2,.737.737,0,0,1,14.02,2.066Z",
    transform: "translate(6.276 7.083)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1710",
    "data-name": "Line 1710",
    y2: 40,
    transform: "translate(176 271)",
    fill: "none",
    stroke: "#d2d3d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(192.039 278.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.04 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30434",
    "data-name": "Path 30434",
    d: "M62.506,167.656a.952.952,0,0,0-.789-.45,1.034,1.034,0,0,0-.992.948,1.765,1.765,0,0,0,.659,1.465,3.631,3.631,0,0,0,.957.685c.065.03.135.064.208.094l.206-.1a3.579,3.579,0,0,0,.93-.713A1.753,1.753,0,0,0,64.3,168.1a1.034,1.034,0,0,0-1.022-.917A.956.956,0,0,0,62.506,167.656Z",
    transform: "translate(-54.991 -151.435)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30435",
    "data-name": "Path 30435",
    d: "M82.429,108.522a.147.147,0,0,0,.212,0,4.374,4.374,0,0,0,1.175-3.074v-.131a.132.132,0,0,1,.188-.129,3.59,3.59,0,0,1,2.072,3.256h0v.04h0v.149h.8v-.188a4.4,4.4,0,0,0-3.2-4.229.132.132,0,0,1-.089-.084,4.4,4.4,0,0,0-4.287-2.993h0l.016.8h.04a3.593,3.593,0,0,1,3.246,1.916.132.132,0,0,1-.119.193h0a4.377,4.377,0,0,0-3.053,1.237.146.146,0,0,0,0,.209Zm.587-3.064a3.584,3.584,0,0,1-.418,1.753.129.129,0,0,1-.2.031l-1.723-1.719a.129.129,0,0,1,.028-.2,3.567,3.567,0,0,1,1.783-.471,3.642,3.642,0,0,1,.377.021.126.126,0,0,1,.111.106A3.57,3.57,0,0,1,83.015,105.458Z",
    transform: "translate(-71.828 -91.609)",
    fill: "#294c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30436",
    "data-name": "Path 30436",
    d: "M79.36,183.018a.147.147,0,0,0,0,.209,4.377,4.377,0,0,0,3.054,1.238h0a.132.132,0,0,1,.119.188,3.591,3.591,0,0,1-3.247,1.918h-.04l-.016.8h0a4.4,4.4,0,0,0,4.288-2.991.133.133,0,0,1,.089-.085,4.4,4.4,0,0,0,3.2-4.229v-.039h0v-.188h-.8v.188h0v.041a3.59,3.59,0,0,1-2.072,3.256.132.132,0,0,1-.188-.128c0-.044,0-.088,0-.132a4.376,4.376,0,0,0-1.175-3.074.147.147,0,0,0-.212,0Zm3.058.645a3.567,3.567,0,0,1-1.783-.471.129.129,0,0,1-.028-.2l1.723-1.722a.128.128,0,0,1,.2.031,3.589,3.589,0,0,1,.377,2.237.127.127,0,0,1-.111.106A3.636,3.636,0,0,1,82.418,183.663Z",
    transform: "translate(-71.764 -162.903)",
    fill: "#294c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30437",
    "data-name": "Path 30437",
    d: "M7.415,105.472a.147.147,0,0,0,0-.209,4.378,4.378,0,0,0-3.053-1.237h0a.132.132,0,0,1-.125-.194,3.591,3.591,0,0,1,3.246-1.918h.04l.015-.8h0a4.394,4.394,0,0,0-4.288,2.994.132.132,0,0,1-.089.084,4.4,4.4,0,0,0-3.2,4.229v.188H.765v-.149h0v-.04h0a3.591,3.591,0,0,1,2.072-3.256.133.133,0,0,1,.188.128c0,.044,0,.088-.006.132A4.375,4.375,0,0,0,4.2,108.5a.146.146,0,0,0,.211,0Zm-3.55-.517a.127.127,0,0,1,.112-.106,3.626,3.626,0,0,1,.377-.021,3.572,3.572,0,0,1,1.783.471.129.129,0,0,1,.028.2l-1.719,1.722a.128.128,0,0,1-.2-.031,3.579,3.579,0,0,1-.417-1.753A3.729,3.729,0,0,1,3.866,104.955Z",
    transform: "translate(0.04 -91.59)",
    fill: "#294c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30438",
    "data-name": "Path 30438",
    d: "M4.445,179.951a.146.146,0,0,0-.211,0,4.376,4.376,0,0,0-1.176,3.074,1.022,1.022,0,0,0,.006.132.134.134,0,0,1-.188.129A3.593,3.593,0,0,1,.8,180.029v-.04h0V179.8H0v.188H0v.039a4.4,4.4,0,0,0,3.2,4.229.133.133,0,0,1,.089.085,4.394,4.394,0,0,0,4.288,2.991h0l-.015-.8h-.04a3.591,3.591,0,0,1-3.25-1.908.132.132,0,0,1,.119-.188h0a4.374,4.374,0,0,0,3.056-1.243.147.147,0,0,0,0-.209Zm-.431,3.655A.129.129,0,0,1,3.9,183.5a3.714,3.714,0,0,1-.042-.484,3.569,3.569,0,0,1,.419-1.752.128.128,0,0,1,.2-.031l1.724,1.718a.129.129,0,0,1-.028.2,3.572,3.572,0,0,1-1.783.471A3.612,3.612,0,0,1,4.014,183.606Z",
    transform: "translate(0.004 -162.867)",
    fill: "#294c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30439",
    "data-name": "Path 30439",
    d: "M189.272,122.353H189.2a.463.463,0,0,1-.426-.463V109.323a.471.471,0,0,1,.464-.463h2.524a6.747,6.747,0,1,1,0,13.493Zm2.486-.942a5.8,5.8,0,1,0,0-11.6h-2.043v11.6Z",
    transform: "translate(-170.988 -98.608)",
    fill: "#294c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30440",
    "data-name": "Path 30440",
    d: "M299.41,109.323a.471.471,0,0,1,.462-.463h6.939a.471.471,0,1,1,0,.942h-6.457v5.339h5.651a.472.472,0,0,1,0,.945h-5.651v5.323h6.457a.471.471,0,0,1,0,.942h-6.978a.462.462,0,0,1-.424-.463Z",
    transform: "translate(-271.208 -98.608)",
    fill: "#294c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30441",
    "data-name": "Path 30441",
    d: "M390.18,109.323a.471.471,0,0,1,.462-.463h6.939a.471.471,0,0,1,0,.942h-6.457v5.339h5.651a.472.472,0,0,1,0,.945h-5.651v5.323h6.457a.471.471,0,0,1,0,.942H390.6a.462.462,0,0,1-.425-.463Z",
    transform: "translate(-353.429 -98.608)",
    fill: "#294c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30442",
    "data-name": "Path 30442",
    d: "M481.9,111.4V122.44a.462.462,0,1,1-.925,0V110.066a.471.471,0,0,1,.171-.52.489.489,0,0,1,.659.116l8.173,11.333V110.008a.471.471,0,1,1,.942,0V122.44a.471.471,0,0,1-.48.463.444.444,0,0,1-.366-.174c-.021-.019-.059-.038-.077-.077Z",
    transform: "translate(-435.654 -99.159)",
    fill: "#294c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30443",
    "data-name": "Path 30443",
    d: "M596.73,121.293V109.92a1.057,1.057,0,0,1,1.061-1.06h6.3a1.07,1.07,0,0,1,0,2.139h-5.223v3.525h4.492a1.07,1.07,0,0,1,0,2.139h-4.492v4.626a1.074,1.074,0,0,1-1.077,1.064,1.057,1.057,0,0,1-1.061-1.06Z",
    transform: "translate(-540.526 -98.608)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30444",
    "data-name": "Path 30444",
    d: "M700.34,122.352a5.562,5.562,0,0,1-5.571-5.569v-6.864a1.045,1.045,0,0,1,1.058-1.06,1.075,1.075,0,0,1,1.081,1.06v6.864a3.431,3.431,0,1,0,6.862,0v-6.864a1.06,1.06,0,0,1,1.078-1.06,1.046,1.046,0,0,1,1.061,1.06v6.864A5.575,5.575,0,0,1,700.34,122.352Z",
    transform: "translate(-629.331 -98.607)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30445",
    "data-name": "Path 30445",
    d: "M823.78,122.568a1.051,1.051,0,1,1-2.1,0V111.35a1.036,1.036,0,0,1,.424-.886,1.061,1.061,0,0,1,1.465.231l6.225,8.616v-7.938a1.049,1.049,0,0,1,1.036-1.036,1.066,1.066,0,0,1,1.061,1.036v11.2a1.071,1.071,0,0,1-1.061,1.06,1.045,1.045,0,0,1-.79-.386.571.571,0,0,1-.094-.115l-6.165-8.562Z",
    transform: "translate(-744.287 -99.883)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30446",
    "data-name": "Path 30446",
    d: "M938.779,121.292V109.92a1.046,1.046,0,0,1,1.057-1.06h2.274a6.747,6.747,0,1,1,0,13.494h-2.274a1.058,1.058,0,0,1-1.057-1.06Zm2.141-1.079h1.194a4.607,4.607,0,0,0,0-9.215H940.92Z",
    transform: "translate(-850.36 -98.608)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30447",
    "data-name": "Path 30447",
    d: "M1.186,5.283V7.818H0V1H2.61a3.2,3.2,0,0,1,1.057.161,2.26,2.26,0,0,1,.781.452,1.939,1.939,0,0,1,.485.689,2.237,2.237,0,0,1,.166.864,2.275,2.275,0,0,1-.166.89,1.769,1.769,0,0,1-.485.666,2.219,2.219,0,0,1-.781.422,3.513,3.513,0,0,1-1.057.145Zm0-.951H2.61A1.816,1.816,0,0,0,3.2,4.247a1.067,1.067,0,0,0,.4-.237.914.914,0,0,0,.232-.368,1.511,1.511,0,0,0,0-.925A1.043,1.043,0,0,0,3.6,2.325a1.141,1.141,0,0,0-.4-.273,1.558,1.558,0,0,0-.589-.1H1.186Z",
    transform: "translate(0.004 -0.903)",
    fill: "#9ea0a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30448",
    "data-name": "Path 30448",
    d: "M68.5,3.692a4.437,4.437,0,0,1-.2,1.394,3.044,3.044,0,0,1-.575,1.044,2.479,2.479,0,0,1-.89.659,2.994,2.994,0,0,1-2.3,0,2.543,2.543,0,0,1-.9-.659,3.033,3.033,0,0,1-.586-1.044,4.353,4.353,0,0,1-.208-1.394V3.345a4.373,4.373,0,0,1,.208-1.4A3.124,3.124,0,0,1,63.625.9a2.5,2.5,0,0,1,.893-.659,3,3,0,0,1,2.3,0,2.493,2.493,0,0,1,.9.659,3.068,3.068,0,0,1,.576,1.05,4.457,4.457,0,0,1,.2,1.4ZM67.31,3.336A4.221,4.221,0,0,0,67.2,2.326a2.158,2.158,0,0,0-.321-.733,1.391,1.391,0,0,0-.518-.447,1.543,1.543,0,0,0-.7-.153,1.507,1.507,0,0,0-.684.153,1.406,1.406,0,0,0-.518.447,2.181,2.181,0,0,0-.328.733,3.978,3.978,0,0,0-.115,1.011v.356A3.991,3.991,0,0,0,64.136,4.7a2.2,2.2,0,0,0,.33.738,1.427,1.427,0,0,0,.523.45,1.531,1.531,0,0,0,.688.152,1.394,1.394,0,0,0,1.211-.6,3.024,3.024,0,0,0,.424-1.752Z",
    transform: "translate(-56.914 -0.01)",
    fill: "#9ea0a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30449",
    "data-name": "Path 30449",
    d: "M136.32,6.136,137.37,1h1.176l-1.575,6.822h-1.13l-1.3-4.981-1.326,4.981h-1.139L130.5,1h1.177l1.06,5.126L134.038,1h.994Z",
    transform: "translate(-118.206 -0.907)",
    fill: "#9ea0a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30450",
    "data-name": "Path 30450",
    d: "M229.128,4.777h-2.8v2.1H229.6v.942h-4.46V1h4.426v.955h-3.242V3.839h2.8Z",
    transform: "translate(-203.932 -0.907)",
    fill: "#9ea0a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30451",
    "data-name": "Path 30451",
    d: "M285.257,5.19h-1.319V7.819H282.75V1h2.4a3.767,3.767,0,0,1,1.044.133,2.149,2.149,0,0,1,.775.394,1.666,1.666,0,0,1,.48.644,2.238,2.238,0,0,1,.165.891,1.915,1.915,0,0,1-.331,1.145,2.1,2.1,0,0,1-.921.71L287.9,7.758v.061h-1.27Zm-1.319-.952h1.219a1.674,1.674,0,0,0,.558-.084,1.11,1.11,0,0,0,.395-.238.948.948,0,0,0,.243-.352,1.239,1.239,0,0,0,.08-.455,1.432,1.432,0,0,0-.075-.476.942.942,0,0,0-.23-.365,1.025,1.025,0,0,0-.4-.234,1.808,1.808,0,0,0-.578-.083h-1.218Z",
    transform: "translate(-256.117 -0.903)",
    fill: "#9ea0a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30452",
    "data-name": "Path 30452",
    d: "M350.328,4.777h-2.8v2.1H350.8v.942h-4.46V1h4.426v.955h-3.242V3.839h2.8Z",
    transform: "translate(-313.718 -0.907)",
    fill: "#9ea0a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30453",
    "data-name": "Path 30453",
    d: "M404,7.82V1h2.015a3.3,3.3,0,0,1,1.249.229,2.768,2.768,0,0,1,.969.654,2.989,2.989,0,0,1,.631,1.025,3.792,3.792,0,0,1,.221,1.339v.338a3.8,3.8,0,0,1-.222,1.337,2.863,2.863,0,0,1-.633,1.019,2.8,2.8,0,0,1-.99.652,3.473,3.473,0,0,1-1.287.23Zm1.186-5.867V6.873h.773a2.133,2.133,0,0,0,.848-.157,1.57,1.57,0,0,0,.607-.452,1.978,1.978,0,0,0,.363-.721,3.471,3.471,0,0,0,.122-.961V4.235a2.6,2.6,0,0,0-.483-1.7,1.719,1.719,0,0,0-1.4-.586Z",
    transform: "translate(-365.947 -0.904)",
    fill: "#9ea0a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30454",
    "data-name": "Path 30454",
    d: "M495.9,7.82V1h2.338a4.151,4.151,0,0,1,.994.109,2.093,2.093,0,0,1,.745.335,1.462,1.462,0,0,1,.471.575,1.941,1.941,0,0,1,.162.827,1.471,1.471,0,0,1-.253.848,1.623,1.623,0,0,1-.74.581,1.635,1.635,0,0,1,.513.233,1.414,1.414,0,0,1,.361.358,1.528,1.528,0,0,1,.214.455,1.914,1.914,0,0,1,.07.515,2.147,2.147,0,0,1-.162.865,1.63,1.63,0,0,1-.471.623,2.065,2.065,0,0,1-.745.377,3.556,3.556,0,0,1-.991.127Zm1.185-3.951h1.162a1.336,1.336,0,0,0,.865-.251.857.857,0,0,0,.312-.71.866.866,0,0,0-.288-.731,1.453,1.453,0,0,0-.9-.225h-1.153Zm0,.872V6.873H498.4a1.6,1.6,0,0,0,.512-.075,1.016,1.016,0,0,0,.377-.213.879.879,0,0,0,.225-.331,1.166,1.166,0,0,0,.074-.427,1.135,1.135,0,0,0-.267-.8,1.133,1.133,0,0,0-.873-.29Z",
    transform: "translate(-449.192 -0.904)",
    fill: "#9ea0a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30455",
    "data-name": "Path 30455",
    d: "M553.317,4.233,554.886,1H556.2l-2.287,4.311V7.822h-1.189V5.311L550.43,1h1.319Z",
    transform: "translate(-498.586 -0.907)",
    fill: "#9ea0a7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfDonationButton);
export default __webpack_public_path__ + "static/media/df-donation-button.1df8cb6549de2ee8b63df5f2d857ef73.svg";
export { ForwardRef as ReactComponent };